module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA6wAAAFoAQMAAABpE+SMAAAABlBMVEUAAACbw97VnZWAAAAAAnRSTlMALqpFwPcAAADMSURBVHja7c1BDcAgAAAxHMy/yznYBHBvCKQ10PHt8GonWq1Wqw03tWO1RzvRarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0Gq1Wm3QarVabdBqtVpt0GrPaNfTBq1Wq9WGa9of6jjLXsaXCZ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/square5.png
// module id = 443
// module chunks = 0